import { WebLayout } from 'components/Layout';
import React from 'react';
import { Head } from 'components/Head';
import { Banner } from '../components/Banner';
import { WhyChooseWire24 } from '../components/WhyChooseWire24';
import { HowItWorks } from '../components/HowItWorks';
import { TrustedByThousands } from '../components/TrustedByThousands';
import { SecurityFAQs } from '../components/SecurityFAQs';

export const Landing = () => {
  return (
    <WebLayout>
      <Head title="Wire24" description="The Future of Money Management" />
      <div className="md:mx-24">
        <Banner />
        <WhyChooseWire24 />
        <HowItWorks />
        <TrustedByThousands />
        <SecurityFAQs />
      </div>
    </WebLayout>
  );
};
